'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FindResult = exports.AutoComplete = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

var _docs = require('redux/modules/docs');

var _ = require('..');

var _utils = require('../../../api/actions/Db/utils');

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  AutoComplete: {
    displayName: 'AutoComplete'
  },
  FindResult: {
    displayName: 'FindResult'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/AutoComplete/AutoComplete.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import Autosuggest from 'react-autosuggest';


// const styles = require('./AutoComplete.scss');

// import { ToolButton } from '..';
/* ---------- */
/*    Data    */
/* ---------- */
var songType = 'songType';
var personType = 'personType';
var minChars = _config2.default.appSettings.minSearchTextLength;
var counter = { citac: 0 };
// const setInputState = {};

// zdroj: http://codepen.io/moroshko/pen/EPZpev


// https://developer.mozilla.org/en/docs/Web/JavaScript/Guide/Regular_Expressions#Using_Special_Characters
// const escapeRegexCharacters = str => {
//   return str.replace(/[.+^${}()|[\]\\]/g, '\\$&');
// };


/* --------------- */
/*    Component    */
/* --------------- */

function getSuggestionValue(suggestion) {
  // eslint-disable-line 
  return suggestion.name;
}

function renderSuggestion(suggestion) {
  // eslint-disable-line 
  var styles = require('./AutoComplete.scss');
  // jak vybarvovat vybraný text: http://codepen.io/moroshko/pen/PZWbzK
  return _react3.default.createElement(
    'span',
    { className: styles[suggestion.type] },
    _react3.default.createElement(_.TreeItem, { item: suggestion, parentItem: suggestion.person, renderRaw: true })
  );
}

var AutoComplete = exports.AutoComplete = _wrapComponent('AutoComplete')((_dec = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setUiProps: _info.setUiProps, findByText: _docs.findByText, setCurrentSearchText: _docs.setCurrentSearchText }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AutoComplete, _Component);

  function AutoComplete() {
    (0, _classCallCheck3.default)(this, AutoComplete);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call(this));

    _this.state = {
      timestamp: 1 * new Date(),
      lastSearchedValue: '',
      value: ''
      // suggestions: getMatchingLanguages(''),
    };

    _this.onChange = _this.onChange.bind(_this);

    if (!(typeof _this.onChange === 'function')) {
      throw new TypeError('Value of "this.onChange" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChange));
    }

    _this.onSuggestionsUpdateRequested = _this.onSuggestionsUpdateRequested.bind(_this);
    // setInputState.reset = ()=>this.setState({value: ''});

    if (!(typeof _this.onSuggestionsUpdateRequested === 'function')) {
      throw new TypeError('Value of "this.onSuggestionsUpdateRequested" violates contract.\n\nExpected:\n(any, any) => any\n\nGot:\n' + _inspect(_this.onSuggestionsUpdateRequested));
    }

    return _this;
  }

  (0, _createClass3.default)(AutoComplete, [{
    key: 'onChange',
    value: function onChange(event) {
      var value = event.target.value.trimLeft();

      // if (!value2.endsWith(' ')) {
      //   if (!value2.endsWith('*')) value2 = value2 + '*';
      // }
      this.setState({
        //    timestamp: 1 * now,
        value: value
      });

      // this.props.setCurrentSearchText(value);

      this.onSuggestionsUpdateRequested(counter.citac, true);
    }
  }, {
    key: 'onSuggestionsUpdateRequested',
    value: function onSuggestionsUpdateRequested(citac, prvniPruchod) {
      var _this2 = this;

      // console.log(citac + ' ' + counter.citac);
      if (citac !== counter.citac) return;
      counter.citac++; // tim stornujeme predchozí naplanované hledání
      // pri prvním pruchodu naplanujeme, pokud furt píše, nic nehledáme
      if (prvniPruchod) {
        // naplanujeme na 'za chvíli'
        var tmp = counter.citac; // protoze closure
        setTimeout(function () {
          _this2.onSuggestionsUpdateRequested(tmp, false);
        }, 500);
        return;
      }

      // console.log('asi budu hledat, vstup se zastavil ' + this.state.value);
      var searchText = (0, _utils.normalizePattern)(this.state.value);
      // informuje globální stav
      this.props.setCurrentSearchText(searchText);
      // = explicitValue || (this.props.docs ? (this.props.docs.searchText || '') : '');
      if (searchText.length < minChars || this.state.lastSearchedValue === searchText) return;
      // console.log('hledám ' + searchText);
      this.props.findByText(searchText);
      this.setState({
        lastSearchedValue: searchText
      });
      this.props.setUiProps({ name: 'showSearchPanel', value: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var value = this.state.value;
      var setUiProps = this.props.setUiProps; // eslint-disable-line no-shadow
      // const ui = this.props.info ? this.props.info.ui : {};

      var showSearchPanelIfSearching = function showSearchPanelIfSearching() {
        setUiProps({ name: 'showSearchPanel', value: true });
      };
      // const globalValue = this.props.docs ? (this.props.docs.searchText || '') : '';
      var styles = require('./AutoComplete.scss');

      return _react3.default.createElement(
        'span',
        { className: styles.autoComplete },
        _react3.default.createElement('input', { placeholder: 'hledat', value: value, onChange: this.onChange, onFocus: showSearchPanelIfSearching }),
        _react3.default.createElement(
          'button',
          { type: 'button', className: styles[value.length > 0 ? 'btnOn' : 'btnOff'] + ' btn btn-danger btn-xs',
            onClick: function onClick() {
              _this3.onChange({ target: { value: '' } });_this3.props.setCurrentSearchText('');
            } },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'remove' })
        )
      );
    }
  }]);
  return AutoComplete;
}(_react2.Component), _class2.propTypes = {
  docs: _react2.PropTypes.object,
  info: _react2.PropTypes.object,
  findByText: _react2.PropTypes.func.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired,
  setCurrentSearchText: _react2.PropTypes.func.isRequired
}, _temp)) || _class));

var FindResult = exports.FindResult = _wrapComponent('FindResult')((_dec2 = (0, _reactRedux.connect)(function (state) {
  return { docs: state.docs, info: state.info.data };
}, function (dispatch) {
  return (0, _redux.bindActionCreators)({ setCurrentSearchText: _docs.setCurrentSearchText, setUiProps: _info.setUiProps }, dispatch);
}), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(FindResult, _Component2);

  function FindResult() {
    (0, _classCallCheck3.default)(this, FindResult);
    return (0, _possibleConstructorReturn3.default)(this, (FindResult.__proto__ || (0, _getPrototypeOf2.default)(FindResult)).apply(this, arguments));
  }

  (0, _createClass3.default)(FindResult, [{
    key: 'transformData',
    value: function transformData(personsImmutable, text) {
      var persons = JSON.parse((0, _stringify2.default)(personsImmutable)); // immutable data potrebujeme zklonovat
      persons.forEach(function (person) {
        // flag, že zpěvák obsahuje hledanou píseň dle názvu písňe bude řazen ve předu, hned za nalezenými interprety; viz dále
        // persons.songs = [...person.songs];// immutable data potrebujeme zklonovat
        var maxPriority = 0;
        person.songs.forEach(function (song) {
          // console.log(JSON.stringify(song) + ' ' +Object.isFrozen(song));
          // rovnou písni nastavíme flag
          song.foundBySongTitle = (0, _utils.testText)(song.name, text).priority;
          maxPriority = Math.max(maxPriority, song.foundBySongTitle);
          return song.foundBySongTitle;
        });
        person.foundBySongTitle = maxPriority;
      });
      var localePersonComparator = function localePersonComparator(obj1, obj2) {
        // nalezené interprety dáme dopředu (mají song.length===0)
        var dd = 1 * (obj2.songs.length === 0) - 1 * (obj1.songs.length === 0);
        if (dd !== 0) return dd;
        // interprety, kteří obsahují piseň, jejiž titulek vyhovuje dáme dopředu
        var dd2 = obj2.foundBySongTitle - obj1.foundBySongTitle;
        if (dd2 !== 0) return dd2;
        // nakonec rozhodne jméno interpreta
        return obj1.name.localeCompare(obj2.name);
      };
      var localeSongComparator = function localeSongComparator(obj1, obj2) {
        // písně, jejiž titulek vyhovuje dáme dopředu
        var dd2 = obj2.foundBySongTitle - obj1.foundBySongTitle;
        if (dd2 !== 0) return dd2;
        // nakonec rozhodne jméno interpreta
        return obj1.name.localeCompare(obj2.name);
      };
      persons.sort(localePersonComparator);
      var res = [];
      persons.forEach(function (person) {
        var parentPerson = { name: person.name, id: person.id, type: personType, foundByInterpretTitle: (0, _utils.testText)(person.name, text).priority > 0 };
        res.push(parentPerson);
        person.songs.sort(localeSongComparator);
        person.songs.forEach(function (song) {
          res.push({ name: song.name, id: song.id, person: parentPerson, type: songType, foundBySongTitle: song.foundBySongTitle });
        });
      });
      return res;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          docs = _props.docs,
          setUiProps = _props.setUiProps; // eslint-disable-line no-shadow

      var text = docs.searchText || ''; // poslední hvězdičku neukazaujeme
      var ui = this.props.info ? this.props.info.ui : {};
      var zobrazitVysledek = !(text.length < minChars) && ui.showSearchPanel;
      // const zobrazitVysledek = ui.showSearchPanel;
      var items = zobrazitVysledek ? this.transformData(docs.searched || [], text) : []; // eslint-disable-line 
      var staleHledam = docs.searchedLastText != text; // eslint-disable-line 
      var nicNenalezeno = zobrazitVysledek && items.length === 0 && !staleHledam;
      var styles = require('./AutoComplete.scss');
      var children = items.map(function (item, keyIndex) {
        var txtElem = void 0;
        if (item.foundBySongTitle || item.foundByInterpretTitle) {
          // interpret se zobrazuje, jen kvuli tomu, že vyhovuje nejaká jeho píseň
          txtElem = _react3.default.createElement(
            'span',
            { className: styles.hilight },
            item.name
          );
        } else {
          txtElem = item.name;
        }
        return _react3.default.createElement(
          _.TreeItem,
          { item: item, parentItem: item.person, key: keyIndex, className: styles[item.type],
            onClick: function onClick() {
              setUiProps({ name: 'showSearchPanel', value: false });
            } },
          txtElem
        );
      });
      var visibleText = text.replace(/\*$/, '');
      var closeBtn = _react3.default.createElement(
        'button',
        { type: 'button', className: 'btn btn-default', onClick: function onClick() {
            setUiProps({ name: 'showSearchPanel', value: false });
          } },
        _react3.default.createElement('span', { className: 'glyphicon glyphicon-menu-up', 'aria-hidden': 'true' })
      );
      var header = _react3.default.createElement(
        'div',
        { className: styles.header },
        closeBtn,
        _react3.default.createElement(
          'div',
          null,
          'V\xFDsledky hled\xE1n\xED: ',
          _react3.default.createElement(
            'span',
            { className: styles.resultSearchText },
            visibleText
          )
        )
      );

      // <ToolButton glyphIconName="text-size" onClick={()=>findByText(null)} /></div>;
      var body = null;
      if (zobrazitVysledek) {
        if (staleHledam) body = _react3.default.createElement(
          'div',
          { className: styles.info },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'search' }),
          ' Hled\xE1m...'
        );else if (nicNenalezeno) body = _react3.default.createElement(
          'div',
          { className: styles.info },
          _react3.default.createElement(_reactBootstrap.Glyphicon, { glyph: 'minus-sign' }),
          ' Nic nanalezeno :-('
        );else body = _react3.default.createElement(
          'ul',
          { className: 'list-group' },
          children
        );
      }

      return _react3.default.createElement(
        'div',
        { className: styles.findResultPanel + (zobrazitVysledek ? '' : ' ' + styles.empty) + ' noPrint' },
        _react3.default.createElement(
          _.HeadFootPanel,
          { header: header },
          body
        )
      );
    }
  }]);
  return FindResult;
}(_react2.Component), _class4.propTypes = {
  docs: _react2.PropTypes.object,
  setUiProps: _react2.PropTypes.func.isRequired,
  setCurrentSearchText: _react2.PropTypes.func.isRequired,
  info: _react2.PropTypes.object
}, _temp2)) || _class3));

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/components/AutoComplete/AutoComplete.js
// module id = 1174
// module chunks = 0